import { MtopError } from "../../errors";
export var MtopException = {
  ErrorType: MtopError,
  exception: function exception(config, Error) {
    var _config$_mtopRes, _res$ret;
    if (!config._mtopRes) return;
    var res = (_config$_mtopRes = config._mtopRes) !== null && _config$_mtopRes !== void 0 ? _config$_mtopRes : {};
    var mtopError = new Error((_res$ret = res.ret) !== null && _res$ret !== void 0 ? _res$ret : [], res, config);
    if (mtopError.retType !== 'SUCCESS') {
      throw mtopError;
    }
    return;
  },
  handler: function handler(e) {
    var _e$data;
    if (e.retType === 'FAIL_SYS_SESSION_EXPIRED' || ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.code) === 601) {
      // 统一登录态处理逻辑
      location.reload();
      return;
    }

    // 这样写避免被Babel、Webpack等插件优化去除
    var _console = console,
      error = _console.error;
    error(e);
    return Promise.reject(e);
  }
};